import { styled } from '@mui/material/styles'
import { Box, Typography, Paper } from '@mui/material'

export const StyledPageTitle = styled(Typography)(({ theme }) => ({
  fontSize: '28px',
  fontWeight: 700,
  color: '#000000',
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    fontSize: '24px',
    marginBottom: theme.spacing(2),
  },
}))

export const StyledSectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 600,
  color: '#000000',
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(3),
  '&:first-of-type': {
    marginTop: 0,
  },
}))

export const StyledDonorSummary = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
}))

export const StyledSummaryGreeting = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 500,
  color: '#000000',
  marginBottom: theme.spacing(1.5),
}))

export const StyledSummaryGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}))

export const StyledSummaryCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  backgroundColor: '#f5f5f5',
  borderRadius: '8px',
}))

export const StyledIconWrapper = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
}))

export const StyledSummaryText = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: 500,
  color: '#000000',
  textAlign: 'center',
}))

export const StyledAppointmentsList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}))
